import React from 'react';
import PropTypes from 'prop-types';
import {Icon, Popup} from 'semantic-ui-react';

import {
    CIDR_WIDE_RANGE_WARNING_TEXT,
    isCidrWiderThan256Ips,
    splitCidrTokens,
} from '@modules/events/utils/eventContentWatermarkingCidrHelper';

export const EventWatermarkingCidrsCell = ({cidrs}) => {
    const cidrTokens = splitCidrTokens(cidrs);

    return (
        <div className='eventWatermarking__cidrsCell'>
            {cidrTokens.map((token, index) => (
                <React.Fragment key={`${token}-${index}`}>
                    {token}
                    {isCidrWiderThan256Ips(token) && (
                        <Popup
                            trigger={
                                <Icon
                                    data-testid='cidr-wide-range-warning'
                                    color='red'
                                    name='warning sign'
                                    className='--height-100-percent --marginLeft-0-5-em'
                                />
                            }
                            flowing
                            content={CIDR_WIDE_RANGE_WARNING_TEXT}
                            hoverable
                        />
                    )}
                    {index < cidrTokens.length - 1 ? ',\n' : ''}
                </React.Fragment>
            ))}
        </div>
    );
};

EventWatermarkingCidrsCell.propTypes = {
    cidrs: PropTypes.string.isRequired,
};
